import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5233c9d1&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=5233c9d1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5233c9d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5233c9d1')) {
      api.createRecord('5233c9d1', component.options)
    } else {
      api.reload('5233c9d1', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=5233c9d1&scoped=true", function () {
      api.rerender('5233c9d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/Footer.vue"
export default component.exports